<template>
  <aside ref="sidebar" class="mc-delivery-track-sidebar">
    <div ref="sidebarWrapper" class="mc-delivery-track-sidebar-wrapper">
      <span ref="sidebarToggle" class="mc-delivery-track-sidebar-toggle" @click="clickToggle()">
        <div class="box-sidebar">
          <i class="mc-fa icon-fill_arrow-ios-left"></i>
          <i class="mc-fa icon-fill_arrowhead-right"></i>
        </div>
      </span>
      <h4 ref="sidebarHeader" class="mc-delivery-track-sidebar-header">
        {{ `Pelacakan Pengiriman ${doNumber}` }}
        <span class="toggle-btn" @click="clickToggle()">
          <i class="mc-fa icon-fill_arrowhead-left"></i>
        </span>
      </h4>
      <div ref="sidebarBody" class="mc-delivery-track-sidebar-body">
        <div
          ref="sidebarStatus"
          class="d-flex justify-content-between mc-delivery-track-sidebar-status"
        >
          <div class="mc-delivery-track-sidebar-status-item active">
            <i class="mc-fa icon-fill_checkmark"></i>
            <p>
              <strong>{{ status }}</strong>
            </p>
          </div>
          <div class="mc-delivery-track-sidebar-status-item-time">
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <b-skeleton />
              </template>
              <p>{{ lastTimeDelivery }}</p>
            </b-skeleton-wrapper>
          </div>
        </div>
        <div class="mc-delivery-track-sidebar-detail mb-3">
          <div
            class="justify-content-between mc-delivery-track-sidebar-detail-item mc-delivery-track-sidebar-detail-item-vehicle mb-3"
          >
            <div class="d-flex align-items-center">
              <img width="40" class="me-2" alt="vehicleIlustration" :src="vehicleIlustration" />
              <P class="m-0">
                <b-skeleton-wrapper :loading="isLoading">
                  <template #loading>
                    <b-skeleton class="m-0" width="60px" />
                  </template>
                  {{ dataDriver.vehicle.license_plate }}
                  <McBadge
                    v-if="dataDriver.vehicle.hull_no"
                    :text="dataDriver.vehicle.hull_no"
                    variant="outlinePlainSecondary"
                    size="medium"
                    type="button"
                  />
                </b-skeleton-wrapper>
              </P>
            </div>
            <hr />
            <b-skeleton-wrapper :loading="isLoading">
              <template #loading>
                <div class="d-flex gap-1">
                  <div class="flex-grow-1">
                    <b-skeleton width="60px" />
                    <b-skeleton width="80px" />
                  </div>
                  <div class="flex-grow-1">
                    <b-skeleton width="60px" />
                    <b-skeleton width="80px" />
                  </div>
                </div>
              </template>
              <div
                class="d-grid gap-1"
                style="grid-template-columns: repeat(2, minmax(0, 1fr))"
              >
                <div class="text-muted" style="grid-column: 1; grid-row: 1">
                  <div>Pengemudi Utama</div>
                  <div>
                    <span class="navy-80">{{ dataDriver.driver.name }}</span>
                    <i v-if="dataDriver.driver.phone_number">
                      ({{ dataDriver.driver.phone_number }})
                    </i>
                  </div>
                </div>
                <div
                  v-if="hasSecondDriver"
                  class="text-muted"
                  style="grid-column: 2; grid-row: 1"
                >
                  <div>Pengemudi Tambahan</div>
                  <div>
                    <span class="navy-80">{{ dataDriver.driver_2.name }}</span>
                    <i v-if="dataDriver.driver_2.phone_number">
                      ({{ dataDriver.driver_2.phone_number }})
                    </i>
                  </div>
                </div>
                <template v-if="hasFeatureEditActivityTrackDOMGM">
                  <template v-if="hasSecondDriver">
                    <template v-if="delivery?.shipment_number && delivery?.reference_number">
                      <div class="text-muted" style="grid-column: 1; grid-row: 2">
                        <div>No. Shipment</div>
                        <div>
                          <span class="navy-80">{{ delivery?.shipment_number }}</span>
                        </div>
                      </div>
                      <div class="text-muted" style="grid-column: 2; grid-row: 2">
                        <div>No. Referensi</div>
                        <div>
                          <span class="navy-80">{{ delivery?.reference_number }}</span>
                        </div>
                      </div>
                    </template>
                    <div
                      v-else-if="delivery?.shipment_number || delivery?.reference_number"
                      class="text-muted"
                      style="grid-column: 1; grid-row: 2"
                    >
                      <div>{{ delivery?.shipment_number ? 'No. Shipment' : 'No. Referensi' }}</div>
                      <div>
                        <span class="navy-80">
                          {{ delivery?.shipment_number || delivery?.reference_number }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      v-if="delivery?.shipment_number"
                      class="text-muted"
                      style="grid-column: 2; grid-row: 1"
                    >
                      <div>No. Shipment</div>
                      <div>
                        <span class="navy-80">{{ delivery?.shipment_number }}</span>
                      </div>
                    </div>
                    <div
                      v-if="delivery?.reference_number"
                      class="text-muted"
                      :style="
                        delivery?.shipment_number
                          ? 'grid-column: 1; grid-row: 2'
                          : 'grid-column: 2; grid-row: 1'
                      "
                    >
                      <div>No. Referensi</div>
                      <div>
                        <span class="navy-80">{{ delivery?.reference_number }}</span>
                      </div>
                    </div>
                  </template>
                </template>
              </div>
            </b-skeleton-wrapper>
          </div>
          <div
            v-if="['Diambil', 'Sedang Transit'].includes(status)"
            class="justify-content-between mc-delivery-track-sidebar-detail-item mc-delivery-track-sidebar-detail-item-last-data mb-3"
          >
            <div class="d-flex justify-content-between">
              <p>{{ 'Update Terakhir' }}</p>
              <b-skeleton-wrapper :loading="isLoadingLastPosition">
                <template #loading>
                  <b-skeleton width="100px" />
                </template>
                <p class="mb-0 teal-300">
                  {{
                    formatIndexDate(lastPositionTime).date +
                    ', ' +
                    formatIndexDate(lastPositionTime).time
                  }}
                </p>
              </b-skeleton-wrapper>
            </div>
            <hr />
            <div class="d-flex align-items-center">
              <i class="mc-fa-last-data icon-fill_pin"></i>
              <b-skeleton-wrapper :loading="isLoadingLastPosition">
                <template #loading>
                  <b-skeleton width="100px" />
                </template>
                <p class="mb-0 teal-300">
                  {{ lastPosition }}
                </p>
              </b-skeleton-wrapper>
            </div>
            <div v-if="isMultiChamber && hasTmsColdChainAccess">
              <b-row>
                <b-col md="12" class="d-flex align-items-center">
                  <i class="mc-fa-last-data icon-fill_driver-violation"></i>
                  <b-skeleton-wrapper :loading="isLoadingLastPosition">
                    <template #loading>
                      <b-skeleton width="50px" />
                    </template>
                    <p class="mb-0 teal-300">
                      {{ lastSpeed + ' Km/Jam' }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12" class="d-flex align-items-center">
                  <i class="mc-fa-last-data icon-fill_thermometer"></i>
                  <p class="mb-0 text-muted me-1">
                    {{ 'Suhu 1: ' }}
                  </p>
                  <b-skeleton-wrapper :key="'temp1'" :loading="isLoadingLastPosition">
                    <template #loading>
                      <b-skeleton width="30px" />
                    </template>
                    <p class="mb-0" :class="isOverTempOne ? 'text-danger' : 'teal-300'">
                      {{ formatTemperature(lastTemperatureOne) }}
                    </p>
                  </b-skeleton-wrapper>
                  <p class="mb-0 text-muted ms-2 me-2">
                    {{ ' | ' }}
                  </p>
                  <p class="mb-0 text-muted me-1">
                    {{ 'Suhu 2: ' }}
                  </p>
                  <b-skeleton-wrapper :key="'temp2'" :loading="isLoadingLastPosition">
                    <template #loading>
                      <b-skeleton width="30px" />
                    </template>
                    <p class="mb-0" :class="isOverTempTwo ? 'text-danger' : 'teal-300'">
                      {{ formatTemperature(lastTemperatureTwo) }}
                    </p>
                  </b-skeleton-wrapper>
                  <p class="mb-0 text-muted ms-2 me-2">
                    {{ ' | ' }}
                  </p>
                  <p class="mb-0 text-muted me-1">
                    {{ 'Suhu 3: ' }}
                  </p>
                  <b-skeleton-wrapper :key="'temp3'" :loading="isLoadingLastPosition">
                    <template #loading>
                      <b-skeleton width="30px" />
                    </template>
                    <p class="mb-0" :class="isOverTempThree ? 'text-danger' : 'teal-300'">
                      {{ formatTemperature(lastTemperatureThree) }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
              </b-row>
              <b-row class="ms-4">
                <b-col md="12" class="d-flex align-items-center">
                  <McBadge
                    :text="'Batas: ' + doTemperature"
                    variant="outlinePlain"
                    size="medium"
                    type="button"
                  />
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <b-row>
                <b-col md="3" class="d-flex align-items-center">
                  <i class="mc-fa-last-data icon-fill_driver-violation"></i>
                  <b-skeleton-wrapper :loading="isLoadingLastPosition">
                    <template #loading>
                      <b-skeleton width="50px" />
                    </template>
                    <p class="mb-0 teal-300">
                      {{ lastSpeed + ' Km/Jam' }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
                <b-col v-if="hasTmsColdChainAccess" md="3" class="d-flex align-items-center">
                  <p class="mb-0 teal-300">
                    {{ '|' }}
                  </p>
                  <i class="mc-fa-last-data icon-fill_thermometer"></i>
                  <b-skeleton-wrapper :loading="isLoadingLastPosition">
                    <template #loading>
                      <b-skeleton width="30px" />
                    </template>
                    <p class="mb-0" :class="isOverTempOne ? 'text-danger' : 'teal-300'">
                      {{ formatTemperature(lastTemperatureOne) }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
                <b-col v-if="hasTmsColdChainAccess" md="6" class="d-flex align-items-center">
                  <McBadge
                    :text="'Batas: ' + doTemperature"
                    variant="outlinePlain"
                    size="medium"
                    type="button"
                  />
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="justify-content-between mc-delivery-track-sidebar-detail-item">
            <div class="d-flex" style="grid-column: 1">
              <div class="d-flex">
                <i class="mc-fa icon-fill_loading"></i>
              </div>
              <div>
                <div class="d-flex justify-content-between">
                  <p>{{ 'Lokasi Ambil' }}</p>
                  <div v-if="canEditData && hasFeatureEditActivityTrackDOMGM">
                    <a
                      v-if="!isEditPickup"
                      class="mc-delivery-track-sidebar-edit-btn"
                      :class="{ 'mc-delivery-track-sidebar-edit-btn__disabled': isLoading }"
                      @click="handleEditPickup()"
                    >
                      <i class="icon-outline_edit"></i>
                      Ubah
                    </a>
                    <div v-if="isEditPickup">
                      <a
                        class="mc-delivery-track-sidebar-edit-btn"
                        @click="handleCancelEditPickup()"
                      >
                        <i class="icon-outline_close"></i>
                        Batal
                      </a>
                      <a
                        :class="[
                          'mc-delivery-track-sidebar-save-btn',
                          { disabled: !pickupEditValidation.isValid },
                        ]"
                        :aria-disabled="!pickupEditValidation.isValid"
                        @click="pickupEditValidation.isValid && handleSavePickup()"
                      >
                        <i class="icon-fill_checkmark"></i>
                        Simpan
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton />
                    </template>
                    <span class="text-muted">{{ delivery?.origin_address?.full_name }}</span>
                  </b-skeleton-wrapper>
                </div>
              </div>
            </div>
            <div class="mc-delivery-track-sidebar-detail-item-point">
              <hr />
              <b-row v-if="!hasFeatureEditActivityTrackDOMGM">
                <b-col md="6" class="mc-delivery-track-sidebar-detail-item-point-time">
                  <p class="text-muted">
                    {{ 'Target Diambil' }}
                  </p>
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton width="40%" />
                    </template>
                    <p class="blue-500 font-size-12">
                      {{
                        delivery?.expected_pickup_on
                          ? formatIndexDate(delivery.expected_pickup_on).date +
                            ', ' +
                            formatIndexDate(delivery.expected_pickup_on).time
                          : '-'
                      }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
                <b-col md="6" class="mc-delivery-track-sidebar-detail-item-point-time">
                  <p class="text-muted">
                    {{ 'Aktual Diambil' }}
                  </p>
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton width="40%" />
                    </template>
                    <p :class="['font-size-12', delivery?.is_late_picked ? 'text-red' : '']">
                      {{ actualPick }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
              </b-row>
              <div v-if="hasFeatureEditActivityTrackDOMGM && !isEditPickup">
                <McAlert
                  v-if="actualPickOutOfOrder && canEditData"
                  class="mb-2"
                  variant="error"
                  html="<strong>Urutan waktu tidak sesuai</strong><br>Ubah waktu untuk menyesuaikan."
                  withIcon
                  customIcon="icon-fill_info"
                  :withGap="false"
                  iconPosition="center"
                />
                <b-row v-if="pickActivityGeofence.in">
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <p class="text-muted">
                      {{ 'Masuk Geolokasi' }}
                    </p>
                  </b-col>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p class="font-size-12">
                        {{ pickActivityGeofence.in }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <p class="text-muted">
                      {{ 'Aktual Diambil' }}
                    </p>
                  </b-col>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p :class="['font-size-12', delivery?.is_late_picked ? 'text-red' : '']">
                        {{ actualPick }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
                <b-row v-if="delivery?.expected_pickup_on">
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p class="text-muted">
                        {{
                          `(Target: ${
                            delivery?.expected_pickup_on
                              ? formatIndexDate(delivery.expected_pickup_on).date +
                                ', ' +
                                formatIndexDate(delivery.expected_pickup_on).time
                              : '-'
                          })`
                        }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
                <b-row v-if="pickActivityGeofence.out">
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <p class="text-muted">
                      {{ 'Keluar Geolokasi' }}
                    </p>
                  </b-col>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p class="font-size-12">
                        {{ pickActivityGeofence.out }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
              </div>
              <div v-if="hasFeatureEditActivityTrackDOMGM && isEditPickup">
                <PickupLocationEditCard
                  :delivery="delivery"
                  :geofenceIn="pickActivityGeofenceRaw.in || ''"
                  :actualPick="actualPickRaw || ''"
                  :actualDrop="actualDropRaw || ''"
                  :geofenceInDrop="dropActivityGeofenceRaw.in || ''"
                  :geofenceOutDrop="dropActivityGeofenceRaw.out || ''"
                  :actualPickTarget="expectedPickupDisplay"
                  :geofenceOut="pickActivityGeofenceRaw.out || ''"
                  @change="handlePickupEditChange"
                  @validation-change="handlePickupEditValidationChange"
                />
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center mc-delivery-track-sidebar-detail-item__arrow">
            <i class="mc-fa icon-fill_arrow-down"></i>
          </div>
          <div class="justify-content-between mc-delivery-track-sidebar-detail-item">
            <div class="d-flex" style="grid-column: 1">
              <div class="d-flex">
                <i class="mc-fa icon-fill_unloading"></i>
              </div>
              <div>
                <div class="d-flex justify-content-between">
                  <p>{{ 'Lokasi Kirim' }}</p>
                  <div v-if="canEditData && hasFeatureEditActivityTrackDOMGM">
                    <a
                      v-if="!isEditDrop"
                      class="mc-delivery-track-sidebar-edit-btn"
                      :class="{ 'mc-delivery-track-sidebar-edit-btn__disabled': isLoading }"
                      @click="handleEditDrop()"
                    >
                      <i class="icon-outline_edit"></i>
                      Ubah
                    </a>
                    <div v-if="isEditDrop">
                      <a class="mc-delivery-track-sidebar-edit-btn" @click="handleCancelEditDrop()">
                        <i class="icon-outline_close"></i>
                        Batal
                      </a>
                      <a
                        :class="[
                          'mc-delivery-track-sidebar-save-btn',
                          { disabled: !dropEditValidation.isValid },
                        ]"
                        :aria-disabled="!dropEditValidation.isValid"
                        @click="dropEditValidation.isValid && handleSaveDrop()"
                      >
                        <i class="icon-fill_checkmark"></i>
                        Simpan
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton />
                    </template>
                    <span class="text-muted">{{ delivery?.destination_address?.full_name }}</span>
                  </b-skeleton-wrapper>
                </div>
              </div>
            </div>
            <div class="mc-delivery-track-sidebar-detail-item-point">
              <hr />
              <b-row v-if="!hasFeatureEditActivityTrackDOMGM">
                <b-col md="6" class="mc-delivery-track-sidebar-detail-item-point-time">
                  <p class="text-muted">
                    {{ 'Target Terkirim' }}
                  </p>
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton width="40%" />
                    </template>
                    <p class="blue-500 font-size-12">
                      {{
                        delivery?.expected_delivered_on
                          ? formatIndexDate(delivery.expected_delivered_on).date +
                            ', ' +
                            formatIndexDate(delivery.expected_delivered_on).time
                          : '-'
                      }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
                <b-col md="6" class="mc-delivery-track-sidebar-detail-item-point-time">
                  <p class="text-muted">
                    {{ 'Aktual Terkirim' }}
                  </p>
                  <b-skeleton-wrapper :loading="isLoading">
                    <template #loading>
                      <b-skeleton width="40%" />
                    </template>
                    <p :class="['font-size-12', delivery?.is_late_delivered ? 'text-red' : '']">
                      {{ actualDrop }}
                    </p>
                  </b-skeleton-wrapper>
                </b-col>
              </b-row>
              <div v-if="hasFeatureEditActivityTrackDOMGM && !isEditDrop">
                <McAlert
                  v-if="actualDropOutOfOrder && canEditData"
                  class="mb-2"
                  variant="error"
                  html="<strong>Urutan waktu tidak sesuai</strong><br>Ubah waktu untuk menyesuaikan."
                  withIcon
                  customIcon="icon-fill_info"
                  :withGap="false"
                  iconPosition="center"
                />
                <b-row v-if="dropActivityGeofence.in">
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <p class="text-muted">
                      {{ 'Masuk Geolokasi' }}
                    </p>
                  </b-col>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p class="font-size-12">
                        {{ dropActivityGeofence.in }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <p class="text-muted">
                      {{ 'Aktual Terkirim' }}
                    </p>
                  </b-col>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p :class="['font-size-12', delivery?.is_late_delivered ? 'text-red' : '']">
                        {{ actualDrop }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
                <b-row v-if="delivery?.expected_delivered_on">
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p class="text-muted">
                        {{
                          `(Target: ${
                            delivery?.expected_delivered_on
                              ? formatIndexDate(delivery.expected_delivered_on).date +
                                ', ' +
                                formatIndexDate(delivery.expected_delivered_on).time
                              : '-'
                          })`
                        }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
                <b-row v-if="dropActivityGeofence.out">
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <p class="text-muted">
                      {{ 'Keluar Geolokasi' }}
                    </p>
                  </b-col>
                  <b-col md="12" class="mc-delivery-track-sidebar-detail-item-point-time">
                    <b-skeleton-wrapper :loading="isLoading">
                      <template #loading>
                        <b-skeleton width="40%" />
                      </template>
                      <p class="font-size-12">
                        {{ dropActivityGeofence.out }}
                      </p>
                    </b-skeleton-wrapper>
                  </b-col>
                </b-row>
              </div>
              <div v-if="hasFeatureEditActivityTrackDOMGM && isEditDrop">
                <DropLocationEditCard
                  :delivery="delivery"
                  :geofenceIn="dropActivityGeofenceRaw.in || ''"
                  :actualDrop="actualDropRaw || ''"
                  :actualDropTarget="expectedDropDisplay"
                  :geofenceOut="dropActivityGeofenceRaw.out || ''"
                  :geofenceInPickup="pickActivityGeofenceRaw.in || ''"
                  :actualPick="actualPickRaw || ''"
                  :geofenceOutPickup="pickActivityGeofenceRaw.out || ''"
                  @change="handleDropEditChange"
                  @validation-change="handleDropEditValidationChange"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="accordion mc-delivery-track-sidebar-accordion" role="tablist">
          <DeliveryInfo v-if="hasAllReferenceData" :data="delivery" :loading="isLoading" />
          <div v-for="(value, index) in doorActivityData" :key="value.sensorCode">
            <SensorActivity
              :data="value.data"
              :doorLevel="doorActivityData.length > 1 ? index + 2 : 2"
              :loading="isLoading"
              :totalData="doorActivityData.length"
              :doorOption="index + 1"
              class="mb-3"
            />
          </div>
          <LoadInfo
            :data="dataLoad"
            :loading="isLoading"
            :status="status"
            :shipmentType="delivery?.shipment_type"
            :transits="delivery?.transits"
            :hasTmsColdChainAccess="hasTmsColdChainAccess"
          />
          <DeliveryHistory :data="dataHistory" :loading="isLoading" />
        </div>
      </div>
    </div>
    <footer ref="sidebarFooter" class="mc-delivery-track-sidebar-footer">
      <span>
        {{ 'Terakhir diupdate pada :' }}
        {{ formatIndexDate(currentDateTime).date + ', ' + formatIndexDate(currentDateTime).time }}
      </span>
      <div>
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('global.text.poweredBy') }} :
        </span>
        <figure class="d-inline-block mb-0">
          <img
            ref="imgCopyrightLogo"
            alt
            :src="getAsset('copyrightLogo', 'general')"
            @load="handleImageLoad()"
          />
        </figure>
      </div>
    </footer>

    <b-modal
      v-model="showMobilePickupEditModal"
      title="Ubah Waktu di Lokasi Ambil"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      modal-class="mc-delivery-track-sidebar-modal"
    >
      <div class="mc-delivery-track-sidebar-modal-body">
        <PickupLocationEditCard
          :delivery="delivery"
          :geofenceIn="pickActivityGeofenceRaw.in || ''"
          :actualPick="actualPickRaw || ''"
          :actualDrop="actualDropRaw || ''"
          :geofenceInDrop="dropActivityGeofenceRaw.in || ''"
          :geofenceOutDrop="dropActivityGeofenceRaw.out || ''"
          :actualPickTarget="expectedPickupDisplay"
          :geofenceOut="pickActivityGeofenceRaw.out || ''"
          @change="handlePickupEditChange"
          @validation-change="handlePickupEditValidationChange"
        />
        <div class="mc-delivery-track-sidebar-modal-footer">
          <b-button variant="outline-primary" @click="showMobilePickupEditModal = false">
            <i class="icon-outline_close"></i>
            Batal
          </b-button>
          <b-button
            variant="primary"
            :disabled="!pickupEditValidation.isValid"
            @click="handleSavePickupMobile()"
          >
            <i class="icon-fill_checkmark"></i>
            Simpan
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showMobileDropEditModal"
      title="Ubah Waktu di Lokasi Kirim"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      modal-class="mc-delivery-track-sidebar-modal"
    >
      <div class="mc-delivery-track-sidebar-modal-body">
        <DropLocationEditCard
          :delivery="delivery"
          :geofenceIn="dropActivityGeofenceRaw.in || ''"
          :actualDrop="actualDropRaw || ''"
          :actualDropTarget="expectedDropDisplay"
          :geofenceOut="dropActivityGeofenceRaw.out || ''"
          :geofenceInPickup="pickActivityGeofenceRaw.in || ''"
          :actualPick="actualPickRaw || ''"
          :geofenceOutPickup="pickActivityGeofenceRaw.out || ''"
          @change="handleDropEditChange"
          @validation-change="handleDropEditValidationChange"
        />
        <div class="mc-delivery-track-sidebar-modal-footer">
          <b-button variant="outline-primary" @click="showMobileDropEditModal = false">
            <i class="icon-outline_close"></i>
            Batal
          </b-button>
          <b-button
            variant="primary"
            :disabled="!dropEditValidation.isValid"
            @click="handleSaveDropMobile()"
          >
            <i class="icon-fill_checkmark"></i>
            Simpan
          </b-button>
        </div>
      </div>
    </b-modal>
  </aside>
</template>
<script>
import McBadge from '@/components/McBadge'
import McAlert from '@/components/McAlert'

import DeliveryHistory from './DeliveryHistory.vue'
import PickupLocationEditCard from './PickupLocationEditCard.vue'
import DropLocationEditCard from './DropLocationEditCard.vue'
import LoadInfo from './LoadInfo.vue'
import SensorActivity from './SensorActivity.vue'
import DeliveryInfo from './DeliveryInfo.vue'
import vehicleIlustration from '@/assets/images/vehicle.svg'

import { mapGetters } from 'vuex'
import { formatIndexDate } from '@/helpers/tzDate'
import debounce from 'lodash'

import { GetAddressData } from '@/services/api/map'
import { EventBus } from '@/router/views/delivery/track/lib/event-bus.js'

export default {
  components: {
    McBadge,
    DeliveryHistory,
    LoadInfo,
    SensorActivity,
    DeliveryInfo,
    PickupLocationEditCard,
    DropLocationEditCard,
    McAlert,
  },
  emits: ['save-pickup', 'save-drop', 'edit-location-time-state-change'],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: null,
    },
    delivery: {
      type: Object,
      default: null,
    },
    doorActivityData: {
      type: Array,
      default: null,
    },
    currentDateTime: {
      type: String,
      default: null,
    },
    detailTripHistories: {
      type: Object,
      default: null,
    },
    hasTmsColdChainAccess: {
      type: Boolean,
      default: false,
    },
    isMultiChamber: {
      type: Boolean,
      default: false,
    },
    vehicle: {
      type: Object,
      default: null,
    },
    hasFeatureEditActivityTrackDOMGM: {
      type: Boolean,
      default: false,
    },
    canEditData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sidebarHeight: 0,
      resizeListener: null,
      isImageLoading: false,
      lastPosition: null,
      lastPositionTime: null,
      lastSpeed: null,
      lastTemperatureOne: null,
      lastTemperatureTwo: null,
      lastTemperatureThree: null,
      isLoadingLastPosition: true,
      vehicleIlustration,
      isEditPickup: false,
      showMobilePickupEditModal: false,
      isEditDrop: false,
      showMobileDropEditModal: false,
      pickupEditForm: {
        geofenceIn: '',
        actualPick: '',
        geofenceOut: '',
      },
      pickupEditValidation: {
        isValid: true,
        message: '',
      },
      dropEditForm: {
        geofenceIn: '',
        actualDrop: '',
        geofenceOut: '',
      },
      dropEditValidation: {
        isValid: true,
        message: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    doNumber() {
      return this.delivery?.number ?? ''
    },
    isLoading() {
      return this.loading
    },
    dataDriver() {
      let targetFleetTask = null

      if (this.delivery?.shipment_type === 'TRANSIT') {
        if (this.status === 'Diambil' || this.status === 'Dijalankan') {
          targetFleetTask = this.delivery.transits.find(
            (item) => item.status === 'UNCOMPLETED'
          )?.fleet_task
        } else {
          targetFleetTask = [...this.delivery.transits]
            .reverse()
            .find((item) => item.status === 'COMPLETED')?.fleet_task
        }
      } else {
        targetFleetTask = this.delivery?.fleet_task
      }

      return {
        driver: {
          name: targetFleetTask?.driver_user?.name || '',
          phone_number: targetFleetTask?.driver_user?.phone_number || '',
        },
        driver_2: {
          name: targetFleetTask?.driver_user_2?.name || '',
          phone_number: targetFleetTask?.driver_user_2?.phone_number || '',
        },
        vehicle: {
          license_plate: targetFleetTask?.vehicle?.license_plate || '',
          hull_no: targetFleetTask?.vehicle?.hull_no || null,
        },
      }
    },
    dataHistory() {
      return this.delivery?.histories
    },
    dataLoad() {
      return this.delivery?.loads
    },
    lastTimeDelivery() {
      if (this.status === 'Dijalankan') {
        return (
          this.formatIndexDate(this.delivery?.timestamp?.started_on).date +
          ', ' +
          this.formatIndexDate(this.delivery?.timestamp?.started_on).time
        )
      }

      if (this.status === 'Diambil') {
        return (
          this.formatIndexDate(this.delivery?.timestamp?.picked_on).date +
          ', ' +
          this.formatIndexDate(this.delivery?.timestamp?.picked_on).time
        )
      }

      if (this.status === 'Sedang Transit') {
        return (
          this.formatIndexDate(this.delivery?.timestamp?.in_transit_on).date +
          ', ' +
          this.formatIndexDate(this.delivery?.timestamp?.in_transit_on).time
        )
      }

      if (this.status === 'Terkirim') {
        return (
          this.formatIndexDate(this.delivery?.timestamp?.delivered_on).date +
          ', ' +
          this.formatIndexDate(this.delivery?.timestamp?.delivered_on).time
        )
      }

      return '-'
    },
    pickupActivityRaw() {
      const originId = this.delivery?.origin_address?.id
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'

      return isTransit
        ? this.delivery?.transits?.find((t) => t.origin_address?.id === originId)
            ?.delivery_order_activity?.pickup
        : this.delivery?.delivery_order_activity?.pickup || {}
    },
    actualPickRaw() {
      return this.pickupActivityRaw?.completed_on || ''
    },
    actualPick() {
      const targetTimestamp = this.actualPickRaw

      if (!targetTimestamp) return '-'

      const { date, time } = this.formatIndexDate(targetTimestamp)
      return `${date}, ${time}`
    },
    expectedPickupDisplay() {
      const targetTimestamp = this.delivery?.expected_pickup_on
      if (!targetTimestamp) return ''

      const { date, time } = this.formatIndexDate(targetTimestamp)
      return `${date}, ${time}`
    },
    actualPickOutOfOrder() {
      return this.pickupActivityRaw?.is_activity_out_of_order
    },
    pickActivityGeofenceRaw() {
      return {
        in: this.pickupActivityRaw?.geofence_in || '',
        out: this.pickupActivityRaw?.geofence_out || '',
      }
    },
    pickActivityGeofence() {
      const geofenceIn = this.pickActivityGeofenceRaw.in
      const geofenceOut = this.pickActivityGeofenceRaw.out

      const formatValue = (value) => {
        if (!value) return null

        const { date, time } = this.formatIndexDate(value)
        return `${date}, ${time}`
      }

      return {
        in: formatValue(geofenceIn),
        out: formatValue(geofenceOut),
      }
    },
    dropActivityRaw() {
      const destinationId = this.delivery?.destination_address?.id
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'

      return isTransit
        ? this.delivery?.transits?.find((t) => t.destination_address?.id === destinationId)
            ?.delivery_order_activity?.drop
        : this.delivery?.delivery_order_activity?.drop || {}
    },
    actualDropRaw() {
      return this.dropActivityRaw?.completed_on || ''
    },
    actualDrop() {
      const targetTimestamp = this.actualDropRaw

      if (!targetTimestamp) return '-'

      const { date, time } = this.formatIndexDate(targetTimestamp)
      return `${date}, ${time}`
    },
    expectedDropDisplay() {
      const targetTimestamp = this.delivery?.expected_delivered_on
      if (!targetTimestamp) return ''

      const { date, time } = this.formatIndexDate(targetTimestamp)
      return `${date}, ${time}`
    },
    actualDropOutOfOrder() {
      return this.dropActivityRaw?.is_activity_out_of_order
    },
    dropActivityGeofenceRaw() {
      return {
        in: this.dropActivityRaw?.geofence_in || '',
        out: this.dropActivityRaw?.geofence_out || '',
      }
    },
    dropActivityGeofence() {
      const geofenceIn = this.dropActivityGeofenceRaw.in
      const geofenceOut = this.dropActivityGeofenceRaw.out

      const formatValue = (value) => {
        if (!value) return null

        const { date, time } = this.formatIndexDate(value)
        return `${date}, ${time}`
      }

      return {
        in: formatValue(geofenceIn),
        out: formatValue(geofenceOut),
      }
    },
    doTemperature() {
      const min_temp = this.delivery?.load_min_temperature
      const max_temp = this.delivery?.load_max_temperature

      if (min_temp != null && max_temp != null) {
        return `${min_temp} ~ ${max_temp}°C`
      } else if (min_temp != null) {
        return `≥ ${min_temp}°C`
      } else if (max_temp != null) {
        return `≤ ${max_temp}°C`
      } else {
        return '-'
      }
    },
    isOverTempOne() {
      return this.checkOverTemp(this.lastTemperatureOne)
    },
    isOverTempTwo() {
      return this.checkOverTemp(this.lastTemperatureTwo)
    },
    isOverTempThree() {
      return this.checkOverTemp(this.lastTemperatureThree)
    },
    hasAllReferenceData() {
      const { aju_number, shipment_number, reference_number } = this.delivery || {}

      return [aju_number, shipment_number, reference_number].some(
        (v) => v !== undefined && v !== null && v !== ''
      )
    },
    hasSecondDriver() {
      return this.dataDriver?.driver_2?.name
    },
  },
  watch: {
    detailTripHistories: {
      handler() {
        this.updateLastPosition()
      },
      deep: true,
    },
  },
  mounted() {
    this.resizeListener = () => debounce(this.calculateCompHeight(true), 150)
    window.addEventListener('resize', this.resizeListener)
    this.emitEditState(false)
  },
  beforeDestroy() {
    this.emitEditState(false)
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    formatIndexDate,
    emitEditState(forcedValue = null) {
      const isEditing =
        typeof forcedValue === 'boolean' ? forcedValue : this.isEditPickup || this.isEditDrop
      this.$emit('edit-location-time-state-change', isEditing)
    },
    clickToggle() {
      const sidebar = this.$refs.sidebarBody
      const isFullMap = document.body.classList.contains('mc-full-map')
      document.body.classList.toggle('mc-full-map')

      if (sidebar && isFullMap) {
        this.$nextTick(() => {
          sidebar.scrollTo({ top: 0 })
          this.calculateModalHeight(true)
        })
        if (window.innerWidth < 890) {
          const controlLeft = document.getElementsByClassName('control-left')
          Array.from(controlLeft).forEach((el) => {
            el.style.bottom = '210px'
          })
          const controlRight = document.getElementsByClassName('control-right')
          Array.from(controlRight).forEach((el) => {
            el.style.bottom = '210px'
          })
        }
      } else {
        this.clearSidebarStyle()
      }
    },
    calculateCompHeight(resize = false) {
      if (window.innerWidth >= 890) {
        this.clearSidebarStyle()
        const mapWrapper = document.getElementById('livetrack-map')
        const sidebarWrapper = this.$refs.sidebarWrapper
        if (mapWrapper && sidebarWrapper) {
          mapWrapper.style.height = ''
          sidebarWrapper.style.height = ''
        }
        return
      }

      if (resize) {
        const sidebarEl = this.$refs.sidebarBody
        if (sidebarEl) {
          sidebarEl.scrollTo({ top: 0 })
        }
      }

      this.calculateModalHeight()
      this.calculateMapHeight()
    },
    calculateMapHeight() {
      const mapWrapper = document.getElementById('livetrack-map')

      if (mapWrapper) {
        mapWrapper.style.height = `calc(100vh - ${this.sidebarHeight}px)`
      }
    },
    calculateModalHeight(withAnimation = false) {
      const isFullMap = document.body.classList.contains('mc-full-map')
      const sidebarTime = this.$refs.mobileSidebarEstimate || this.$refs.mobileSidebarActual
      const sidebarToggle = this.$refs.sidebarToggle
      const sidebarHeader = this.$refs.sidebarHeader
      const sidebarStatus = this.$refs.sidebarStatus
      const sidebarFooter = this.$refs.sidebarFooter
      const sidebar = this.$refs.sidebar
      const sidebarWrapper = this.$refs.sidebarWrapper

      let sidebarHeight
      if (
        sidebarTime &&
        sidebarToggle &&
        sidebarHeader &&
        sidebarStatus &&
        sidebarFooter &&
        !isFullMap
      ) {
        sidebarHeight =
          sidebarTime.offsetHeight +
          sidebarToggle.offsetHeight +
          sidebarHeader.offsetHeight +
          sidebarStatus.offsetHeight +
          30 +
          sidebarFooter.offsetHeight
      }

      if (sidebar && sidebarWrapper) {
        if (!withAnimation) {
          sidebar.style.transition = 'none'
        }

        sidebarWrapper.style.height = `calc(100% - ${sidebarFooter.offsetHeight}px)`

        if (sidebarHeight) {
          this.sidebarHeight = sidebarHeight
          sidebar.style.height = `${sidebarHeight}px`
          sidebar.style.top = `calc(100% - ${sidebarHeight}px)`
        }

        if (!withAnimation) {
          sidebar.style.transition = ''
        }
      }
    },
    clearSidebarStyle() {
      if (window.innerWidth < 890) {
        const controlLeft = document.getElementsByClassName('control-left')
        Array.from(controlLeft).forEach((el) => {
          el.style.bottom = 'calc(100% - 90px)'
        })
        const controlRight = document.getElementsByClassName('control-right')
        Array.from(controlRight).forEach((el) => {
          el.style.bottom = 'calc(100% - 90px)'
        })
      }
      const sidebar = this.$refs.sidebar
      if (sidebar) {
        sidebar.style.height = ''
        sidebar.style.top = ''
      }
    },
    handleImageLoad() {
      this.isImageLoading = false
    },
    async getLastPosition(latitude, longitude) {
      if (!latitude || !longitude) {
        this.isLoadingLastPosition = false
        return '-'
      }
      const address = await GetAddressData(latitude, longitude)
      this.isLoadingLastPosition = false
      return address.display_name
    },
    async updateLastPosition() {
      this.isLoadingLastPosition = true
      if (this.status !== 'Terkirim') {
        this.lastPosition = await this.getLastPosition(
          this.vehicle?.latitude,
          this.vehicle?.longitude
        )
        this.lastPositionTime = this.vehicle?.lastPositionStatus
        this.lastSpeed = this.vehicle?.calculatedSpeed ?? '-'
        this.lastTemperatureOne = this.vehicle?.temperature?.[0] ?? '-'
        this.lastTemperatureTwo = this.vehicle?.temperature?.[1] ?? '-'
        this.lastTemperatureThree = this.vehicle?.temperature?.[2] ?? '-'
        return
      }

      const lastTrip = this.detailTripHistories?.data
        ?.slice()
        .reverse()
        .find((item) => !item.break)

      this.lastPosition = await this.getLastPosition(lastTrip?.latitude, lastTrip?.longitude)
      this.lastPositionTime = lastTrip?.sentOn ?? null
      this.lastSpeed = lastTrip?.speed ?? '-'
      this.lastTemperatureOne = lastTrip?.temperature ?? '-'
      this.lastTemperatureTwo = lastTrip?.temperature2 ?? '-'
      this.lastTemperatureThree = lastTrip?.temperature3 ?? '-'
    },
    formatTemperature(val) {
      if (val === null || val === undefined || val === '' || val === '-') {
        return '-'
      }
      return `${val}°C`
    },
    checkOverTemp(val) {
      const currentTemp = Number(val)
      if (!Number.isFinite(currentTemp)) {
        return false
      }

      const minTemp = Number(this.delivery?.load_min_temperature)
      const maxTemp = Number(this.delivery?.load_max_temperature)
      const hasMin = Number.isFinite(minTemp)
      const hasMax = Number.isFinite(maxTemp)

      if (!hasMin && !hasMax) {
        return false
      }

      if (hasMax && currentTemp > maxTemp) {
        return true
      }

      if (hasMin && currentTemp < minTemp) {
        return true
      }

      return false
    },
    handleEditPickup() {
      if (window.innerWidth < 890) {
        this.showMobilePickupEditModal = true
      }
      this.pickupEditForm = {
        geofenceIn: this.pickActivityGeofenceRaw.in || '',
        actualPick: this.actualPickRaw || '',
        geofenceOut: this.pickActivityGeofenceRaw.out || '',
      }
      this.isEditDrop = false
      if (window.innerWidth >= 890) {
        this.isEditPickup = true
      }
      this.emitEditState()
    },
    handleSavePickupMobile() {
      this.handleSavePickup()
      this.showMobilePickupEditModal = false
    },
    handleSaveDropMobile() {
      this.handleSaveDrop()
      this.showMobileDropEditModal = false
    },
    handleCancelEditPickup() {
      this.pickupEditForm = {
        geofenceIn: '',
        actualPick: '',
        geofenceOut: '',
      }
      this.pickupEditValidation = {
        isValid: true,
        message: '',
      }
      this.isEditPickup = false
      this.emitEditState()
    },
    handlePickupEditChange(payload) {
      this.pickupEditForm = {
        geofenceIn: payload?.geofenceIn || '',
        actualPick: payload?.actualPick || '',
        geofenceOut: payload?.geofenceOut || '',
      }
      EventBus.$emit && EventBus.$emit('location-time-edit-change')
    },
    handlePickupEditValidationChange(payload) {
      this.pickupEditValidation = {
        isValid: payload?.isValid !== false,
        message: payload?.message || '',
      }
    },
    handleSavePickup() {
      if (!this.pickupEditValidation.isValid) {
        const errorMessage = this.pickupEditValidation.message || 'Periksa kembali data waktu.'
        if (this.$mcToast && this.$mcToast.error) {
          this.$mcToast.error(errorMessage)
        }
        return
      }

      const payload = {
        geofence_in: this.pickupEditForm.geofenceIn || null,
        completed_on: this.pickupEditForm.actualPick || null,
        geofence_out: this.pickupEditForm.geofenceOut || null,
      }

      this.$emit('save-pickup', payload)
      this.isEditPickup = false
      this.emitEditState()
    },
    handleEditDrop() {
      if (window.innerWidth < 890) {
        this.showMobileDropEditModal = true
      }
      this.dropEditForm = {
        geofenceIn: this.dropActivityGeofenceRaw.in || '',
        actualDrop: this.actualDropRaw || '',
        geofenceOut: this.dropActivityGeofenceRaw.out || '',
      }
      this.dropEditValidation = {
        isValid: true,
        message: '',
      }
      this.isEditPickup = false
      if (window.innerWidth >= 890) {
        this.isEditDrop = true
      }
      this.emitEditState()
    },
    handleCancelEditDrop() {
      this.dropEditForm = {
        geofenceIn: '',
        actualDrop: '',
        geofenceOut: '',
      }
      this.dropEditValidation = {
        isValid: true,
        message: '',
      }
      this.isEditDrop = false
      this.emitEditState()
    },
    handleDropEditChange(payload) {
      this.dropEditForm = {
        geofenceIn: payload?.geofenceIn || '',
        actualDrop: payload?.actualDrop || '',
        geofenceOut: payload?.geofenceOut || '',
      }
      EventBus.$emit && EventBus.$emit('location-time-edit-change')
    },
    handleDropEditValidationChange(payload) {
      this.dropEditValidation = {
        isValid: payload?.isValid !== false,
        message: payload?.message || '',
      }
    },
    handleSaveDrop() {
      if (!this.dropEditValidation.isValid) {
        const errorMessage = this.dropEditValidation.message || 'Periksa kembali data waktu.'
        if (this.$mcToast && this.$mcToast.error) {
          this.$mcToast.error(errorMessage)
        }
        return
      }

      const payload = {
        geofence_in: this.dropEditForm.geofenceIn || null,
        completed_on: this.dropEditForm.actualDrop || null,
        geofence_out: this.dropEditForm.geofenceOut || null,
      }

      this.$emit('save-drop', payload)
      this.isEditDrop = false
      this.emitEditState()
    },
  },
}
</script>
